import $root from '@/proto/proto-bundle'

export const ItemService = {
  decodeItems: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('ItemsResponse')
    resolve(container.decode(new Uint8Array(body)))
  }),
  decodeItem: ({ body }) => new Promise((resolve) => {
    const container = $root.lookup('Item')
    resolve(container.decode(new Uint8Array(body)))
  }),
  encodeRemoveItemsRequest: ({ fileId }) => new Promise((resolve) => {
    const requestBuilder = $root.lookup('RemoveItemsRequest')
    resolve(requestBuilder.encode({ fileId }).finish())
  })
}
